import type { TranslationSchema } from '../pt-BR';
import type { DeepPartialStrings } from '../types';

export const tags = {
    layout: {
        listTitle: 'Tags',
        newTitle: 'New tag',
        editTitle: 'Edit tag',
    },
    list: {
        noTransactions: 'No transactions',
        transactionCount_one: '{{count}} transaction',
        transactionCount_other: '{{count}} transactions',
        emptyTitle: 'No tags',
        emptySubtitle: 'Create tags to organize your transactions by context (e.g. travel, reimbursement).',
        emptyAction: 'Create tag',
    },
    form: {
        previewPlaceholder: 'your tag',
        previewLabel: 'Preview',
        nameLabel: 'Name',
        namePlaceholder: 'tag name',
        nameHintNew: 'E.g. travel, reimbursement, gift. Always lowercase — it shows up as <0>#{{slug}}</0> in your statement.',
        nameHintEdit_zero: 'No transactions use this tag yet — it shows up as <0>#{{slug}}</0> in your statement.',
        nameHintEdit_one: 'Renaming won\'t break anything: <0>{{count}} transaction</0> will show <0>#{{slug}}</0>.',
        nameHintEdit_other: 'Renaming won\'t break anything: the <0>{{count}} transactions</0> will show <0>#{{slug}}</0>.',
        colorLabel: 'Color',
        deleteAction: 'Delete tag',
        createButton: 'Create tag',
        saveButton: 'Save changes',
        nameRequiredError: 'Give the tag a name',
        saveError: 'Couldn\'t save the tag.',
    },
    deleteDialog: {
        title: 'Delete tag',
        messageWithUsage_one: 'The tag will be removed from {{count}} transaction. The transactions themselves will be kept. This action can\'t be undone.',
        messageWithUsage_other: 'The tag will be removed from {{count}} transactions. The transactions themselves will be kept. This action can\'t be undone.',
        messageUnused: 'The tag will be deleted. This action can\'t be undone.',
        confirm: 'Delete',
    },
    picker: {
        title: 'Tags',
        searchPlaceholder: 'Search or create tag...',
        create: 'Create "{{query}}"',
        empty: 'No tags created',
        menuTitle: 'Tag "{{name}}"',
        edit: 'Edit',
        editDescription: 'Rename or change the color',
        delete: 'Delete tag',
        deleteDescription: 'Removes the tag from all transactions',
    },
    batchSheet: {
        title: 'Add tags',
        apply_one: 'Apply to {{count}} transaction',
        apply_other: 'Apply to {{count}} transactions',
    },
} satisfies DeepPartialStrings<TranslationSchema['tags']>;
